import { createBrowserRouter } from "react-router-dom";

import { RootLayout } from "@/routes/_root";
import { LandingHubPage } from "@/platform/routes/landing-hub";
import { EinsteinLandingPage } from "@/tenants/einstein/routes/landing";
import { UspLandingPage } from "@/tenants/usp/routes/landing";
import { UspWaitlistPage } from "@/tenants/usp/routes/waitlist";
import { UspBancaFuvestPage } from "@/tenants/usp/routes/banca-fuvest";
import { UspDiagnosticoPage } from "@/tenants/usp/routes/diagnostico";
import { UspOnboardingPage } from "@/tenants/usp/routes/onboarding";
import { UspSimulador1aFasePage } from "@/tenants/usp/routes/simulador-1afase";
import { UspRedacaoPage } from "@/tenants/usp/routes/redacao";
import { UspSegundaFasePage } from "@/tenants/usp/routes/segunda-fase";
import { UspMetodoPage } from "@/tenants/usp/routes/metodo";
import { UspRevisarPage } from "@/tenants/usp/routes/revisar";
import { UspPlanoPage } from "@/tenants/usp/routes/plano";
import { UspPainelPage } from "@/tenants/usp/routes/painel";
import { UspEvolucaoPage } from "@/tenants/usp/routes/evolucao";
import { UspSimuladorHubPage } from "@/tenants/usp/routes/simulador";
import { NotFoundPage } from "@/routes/not-found";
import { MethodPage } from "@/tenants/einstein/routes/method";
import { PricingPage } from "@/routes/pricing";
import { SignInPage, SignUpPage } from "@/routes/auth";
import { DiagnosisPage } from "@/tenants/einstein/routes/diagnosis";
import { DiagnosisSessionPage } from "@/tenants/einstein/routes/diagnosis-session";
import { EssayPage } from "@/tenants/einstein/routes/essay";
import { DiscursivePage } from "@/tenants/einstein/routes/discursive";
import { StudyPlanPage } from "@/tenants/einstein/routes/study-plan";
import { ReviewPage } from "@/tenants/einstein/routes/review";
import { ProgressPage } from "@/tenants/einstein/routes/progress";
import { AdminIndexPage } from "@/routes/admin-index";
import { AdminUspQaPage } from "@/routes/admin-usp-qa";
import { AdminQAPage } from "@/routes/admin-qa";
import { AdminWaitlistPage } from "@/routes/admin-waitlist";
import { AdminLlmCallsPage } from "@/routes/admin-llm-calls";
import { AdminUsersPage } from "@/routes/admin-users";
import { AdminUserDetailPage } from "@/routes/admin-user-detail";
import { AdminSubscriptionsPage } from "@/routes/admin-subscriptions";
import { AdminMetricsPage } from "@/routes/admin-metrics";
import { AdminAuditPage } from "@/routes/admin-audit";
import { VerifyOtpPage } from "@/routes/verify-otp";
import { PasswordResetPage, PasswordResetRequestPage } from "@/routes/password-reset";
import { AuthCallbackPage } from "@/routes/auth-callback";
import { AccountPage } from "@/routes/account";
import { SimulationPage } from "@/tenants/einstein/routes/simulation";
import { AboutPage } from "@/routes/about";
import { OnboardingPage } from "@/tenants/einstein/routes/onboarding";
import { DashboardPage } from "@/tenants/einstein/routes/dashboard";
import {
  CitationPolicyPage,
  ContactPage,
  PrivacyPage,
  TermsPage,
} from "@/routes/legal";
import { ComingSoonPage } from "@/routes/coming-soon";
import {
  RequireAdmin,
  RequireAuth,
  RequireGuest,
  RequireSubscription,
} from "@/platform/auth/guards";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      { index: true, element: <LandingHubPage /> },
      { path: "einstein", element: <EinsteinLandingPage /> },
      { path: "usp", element: <UspLandingPage /> },
      {
        path: "usp/lista-de-espera",
        element: (
          <RequireAuth>
            <UspWaitlistPage />
          </RequireAuth>
        ),
      },
      // ─── Stubs USP — núcleo do produto destrava após Gates 1+2+3 ───
      {
        path: "usp/metodo",
        element: <UspMetodoPage />,
      },
      {
        path: "usp/banca-fuvest",
        element: <UspBancaFuvestPage />,
      },
      {
        path: "usp/diagnostico",
        element: <UspDiagnosticoPage />,
      },
      {
        path: "usp/painel",
        element: (
          <RequireSubscription>
            <UspPainelPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/plano",
        element: (
          <RequireSubscription>
            <UspPlanoPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/revisar",
        element: (
          <RequireSubscription>
            <UspRevisarPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/redacao",
        element: (
          <RequireSubscription>
            <UspRedacaoPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/1afase",
        element: (
          <RequireSubscription>
            <UspSimulador1aFasePage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/2afase",
        element: (
          <RequireSubscription>
            <UspSegundaFasePage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/simulador",
        element: (
          <RequireSubscription>
            <UspSimuladorHubPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/evolucao",
        element: (
          <RequireSubscription>
            <UspEvolucaoPage />
          </RequireSubscription>
        ),
      },
      {
        path: "usp/onboarding",
        element: (
          <RequireSubscription>
            <UspOnboardingPage />
          </RequireSubscription>
        ),
      },
      { path: "metodo", element: <MethodPage /> },
      { path: "precos", element: <PricingPage /> },
      {
        path: "entrar",
        element: (
          <RequireGuest>
            <SignInPage />
          </RequireGuest>
        ),
      },
      {
        path: "cadastro",
        element: (
          <RequireGuest>
            <SignUpPage />
          </RequireGuest>
        ),
      },
      { path: "verificar", element: <VerifyOtpPage /> },
      {
        path: "onboarding",
        element: (
          <RequireAuth>
            <OnboardingPage />
          </RequireAuth>
        ),
      },
      {
        path: "painel",
        element: (
          <RequireSubscription>
            <DashboardPage />
          </RequireSubscription>
        ),
      },
      {
        path: "plano",
        element: (
          <RequireSubscription>
            <StudyPlanPage />
          </RequireSubscription>
        ),
      },
      {
        path: "revisar",
        element: (
          <RequireSubscription>
            <ReviewPage />
          </RequireSubscription>
        ),
      },
      {
        path: "evolucao",
        element: (
          <RequireSubscription>
            <ProgressPage />
          </RequireSubscription>
        ),
      },
      {
        path: "admin",
        element: (
          <RequireAdmin>
            <AdminIndexPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/qa",
        element: (
          <RequireAdmin>
            <AdminQAPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/usp/qa",
        element: (
          <RequireAdmin>
            <AdminUspQaPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/waitlist",
        element: (
          <RequireAdmin>
            <AdminWaitlistPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/llm-calls",
        element: (
          <RequireAdmin>
            <AdminLlmCallsPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/usuarios",
        element: (
          <RequireAdmin>
            <AdminUsersPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/usuarios/:id",
        element: (
          <RequireAdmin>
            <AdminUserDetailPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/assinaturas",
        element: (
          <RequireAdmin>
            <AdminSubscriptionsPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/metricas",
        element: (
          <RequireAdmin>
            <AdminMetricsPage />
          </RequireAdmin>
        ),
      },
      {
        path: "admin/auditoria",
        element: (
          <RequireAdmin>
            <AdminAuditPage />
          </RequireAdmin>
        ),
      },
      { path: "diagnostico", element: <DiagnosisPage /> },
      {
        path: "diagnostico/sessao",
        element: (
          <RequireSubscription>
            <DiagnosisSessionPage />
          </RequireSubscription>
        ),
      },
      { path: "sobre", element: <AboutPage /> },
      { path: "termos", element: <TermsPage /> },
      { path: "terms", element: <TermsPage /> },
      { path: "privacidade", element: <PrivacyPage /> },
      { path: "privacy", element: <PrivacyPage /> },
      { path: "contato", element: <ContactPage /> },
      { path: "politica-de-citacao", element: <CitationPolicyPage /> },
      {
        path: "simulador",
        element: (
          <RequireSubscription>
            <SimulationPage />
          </RequireSubscription>
        ),
      },
      {
        path: "redacao",
        element: (
          <RequireSubscription>
            <EssayPage />
          </RequireSubscription>
        ),
      },
      {
        path: "discursivas",
        element: (
          <RequireSubscription>
            <DiscursivePage />
          </RequireSubscription>
        ),
      },
      {
        path: "banca-vunesp",
        element: (
          <ComingSoonPage
            kicker="Banca Vunesp"
            title="Assinatura da banca, por dentro."
            description="Padrões de enunciado, distratores plausíveis, redação Vunesp sem proposta de intervenção e o que a banca premia e penaliza."
          />
        ),
      },
      { path: "recuperar", element: <PasswordResetRequestPage /> },
      { path: "redefinir", element: <PasswordResetPage /> },
      { path: "auth/callback", element: <AuthCallbackPage /> },
      {
        path: "conta",
        element: (
          <RequireAuth>
            <AccountPage />
          </RequireAuth>
        ),
      },
      {
        path: "checkout",
        element: (
          <ComingSoonPage
            kicker="Checkout"
            title="Pagamentos serão habilitados em breve."
            description="Estamos finalizando a integração com o provedor de pagamento. Cadastre-se para ser avisada."
          />
        ),
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
